export const NotificationSymbol = Symbol('notification');
